import React from 'react';

import { CtaOption } from '../CtaOption/ctaOption';
import { ButtonVariant } from '../../../types/types';
import { ButtonProps } from '../../../types/interfaces/buttonInterface';

interface CtaOptionCreateAccountProps {
  onClick?: ButtonProps['onClick']
}

export const CtaOptionCreateAccount: React.FC<CtaOptionCreateAccountProps> = ({
  onClick = () => {
    console.error(
      '[CtaOptionCreateAccount]: No onClick handler provided. This button is non-functional.'
    );
  },
}) => {
  return (
    <CtaOption
      description=""
      innerText="Sign in / Join"
      variant={ButtonVariant.LOGIN_JOIN}
      onClick={onClick}
    />
  );
};
